import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EntraAuthService } from '@client/auth/services/entra-auth.service';

/** Auth state is settled by the app initializer before the first navigation, so these guards are synchronous. */
export const authGuard: CanActivateFn = () =>
    inject(EntraAuthService).isReady() ? true : inject(Router).createUrlTree(['/sign-in']);

/** Signed-in users (and Entra-disabled clients) skip the sign-in page; this also ends the hosted redirect landing. */
export const signInGuard: CanActivateFn = () =>
    inject(EntraAuthService).isReady() ? inject(Router).createUrlTree(['/work-packages']) : true;
